import { useHttp } from '../http'

export const useWebhookLogHttp = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`webhook-logs`, payload)
    }

    return {
        get,
    }
}
